import { render, staticRenderFns } from "./scrutineerList.vue?vue&type=template&id=48021a45&scoped=true&"
import script from "./scrutineerList.vue?vue&type=script&lang=js&"
export * from "./scrutineerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48021a45",
  null
  
)

export default component.exports